<div class="advancedCFAccess__section">
  <h6 class="shareModalHeader">
    {{ 'activity' | ppTranslate }}

    <i
      ppTooltip
      [ppOptions]="{ placement: 'right' }"
      class="fa fa-info-circle settingsSection__header-info"
      aria-hidden="true"
      [ppTitle]="'activity_AAL_description' | ppTranslate"
      [ppMobileTooltip]="true"
    ></i>
  </h6>

  <pp-toggle
    ppId="toggleShowTimeline"
    (ppAction)="correctProperty(EGoogleEventLabel.TIMELINE)"
    [ppChecked]="ppShare.advancedAccessLevels.timeline.permission.read"
    [ppReverseLayout]="true"
    [ppDisabled]="timelineDisabled"
    ppStyle="blue"
  >
    <span class="toggleInnerText">{{ 'show_activity' | ppTranslate }}</span>
  </pp-toggle>
</div>
